export const isMyAuctionsPage = (pathname: string): boolean => {
  const path = pathname.replace('/auctions/', '');

  return ['following', 'in_prog', 'won', 'didnt_win', 'all'].includes(path);
};
